// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._14wy7po0 {
  height: 100%;
}
._14wy7po1 {
  max-width: 380px;
  width: 100%;
}
._14wy7po3:before {
  content: "";
  display: block;
  width: 100%;
  height: 1px;
  background: var(--_18w76bw28);
  position: absolute;
  top: 14px;
}
@media screen and (min-width: 768px) {
  ._14wy7po1 {
    width: auto;
    padding-left: var(--_18w76bwo);
    padding-right: var(--_18w76bwo);
  }
  ._14wy7po3:before {
    top: 22px;
  }
}
@media screen and (min-width: 769px) {
  ._14wy7po2 {
    padding: 0 10px;
  }
}
@media screen and (max-width: 768px) {
  ._14wy7po2 {
    padding: 0 5px;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,YAAY;AACd;AACA;EACE,gBAAgB;EAChB,WAAW;AACb;AACA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,WAAW;EACX,6BAA6B;EAC7B,kBAAkB;EAClB,SAAS;AACX;AACA;EACE;IACE,WAAW;IACX,8BAA8B;IAC9B,+BAA+B;EACjC;EACA;IACE,SAAS;EACX;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":["._14wy7po0 {\n  height: 100%;\n}\n._14wy7po1 {\n  max-width: 380px;\n  width: 100%;\n}\n._14wy7po3:before {\n  content: \"\";\n  display: block;\n  width: 100%;\n  height: 1px;\n  background: var(--_18w76bw28);\n  position: absolute;\n  top: 14px;\n}\n@media screen and (min-width: 768px) {\n  ._14wy7po1 {\n    width: auto;\n    padding-left: var(--_18w76bwo);\n    padding-right: var(--_18w76bwo);\n  }\n  ._14wy7po3:before {\n    top: 22px;\n  }\n}\n@media screen and (min-width: 769px) {\n  ._14wy7po2 {\n    padding: 0 10px;\n  }\n}\n@media screen and (max-width: 768px) {\n  ._14wy7po2 {\n    padding: 0 5px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
